/* globals VXConfig */
import React, {lazy}              from 'react';
import PropTypes                   from 'prop-types';
import TopLiveCamGirlsBlock        from './Block/TopLiveCamGirlsBlock';
import CategoriesBlock             from './Block/CategoriesBlock';
import FavoritesBlock              from './Block/FavoritesBlock';
import TrendingVideosBlock         from './Block/TrendingVideosBlock';
import VideoStationBlock           from './Block/VideoStationBlock';
import NewGirlsBlock               from './Block/NewGirlsBlock';
import Flux                        from '../../flux/Flux';
import Constants                   from './../../flux/Constants';
import TeaserProvider              from '../VXMobile/Teaser/TeaserProvider';
import TeaserBlock                 from './Block/TeaserBlock';
import DailybonusBlock             from './Block/DailybonusBlock';
import Competitions                from '../Competitions/Competitions';
import VIP30Block                  from "../Video/Block/VIP30Block";
import UrlBuilder                  from "../../utils/UrlBuilder";
import TVSeriesBlock               from "../TV/Block/TVSeriesBlock";
import TVSeriesHomepageGrid        from "../TV/TVSeriesHomepageGrid";
import {getSeoHeadlineTranslation} from "../../utils/TranslationHelper";
import CamShowsBlock               from './Block/CamShowsBlock';
import FeedBlock                   from "./Block/FeedBlock";
import ErrorBoundary               from '../../utils/ErrorBoundary';
import withSuspense                from '../HigherOrderComponents/Utility/withSuspense';
import {sortAndFilterBlockConfigs} from '../../utils/CommonUtils.js';

const Cams              = lazy(() => import('../Cams/Cams.js'));
const WelcomeClipsBlock = lazy(() => import('./Block/WelcomeClipsBlock'));
const PageNavigation    = lazy(() => import('../PageNavigation'));

const distance = 80;  //the navi item should been active when window.scrollY touches the top of the block

class AllBlocks extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			blocks:        {},
			activeItemId:  null,
			camShowsBlock: null,
			feedBlock:     null,
			contestsBlock: null,
		};

		this.setContestsBlock = this.setContestsBlock.bind(this);
		this.setCamShowsBlock = this.setCamShowsBlock.bind(this);
		this.setFeedBlock     = this.setFeedBlock.bind(this);
		this.onScroll         = this.onScroll.bind(this);
	}

	componentDidMount() {
		this.setBlocks();
		Flux.Browser.addWindowScrollListener(this.onScroll);
	}

	componentWillUnmount() {
		Flux.Browser.removeWindowScrollListener(this.onScroll);
	}

	getBlockPosition(el) {
		if (el) {
			return Math.round(el.getBoundingClientRect().top + window.scrollY - distance);
		}
		return 0;
	}

	getBlockHeight(el) {
		if (el) {
			return Math.round(el.getBoundingClientRect().height);
		}
		return 0;
	}

	setBlocks() {
		const items = {
			favoriteBlock:     document.getElementById("favorite-block"),
			topLiveBlock:      document.getElementById("top-live-block"),
			dailyBonusBlock:   document.getElementById("dailybonus-block"),
			vip30Block:        document.getElementById("vip30-block"),
			camShowsBlock:     this.state.camShowsBlock !== null ? this.state.camShowsBlock : document.getElementById("cam-shows-block"),
			feedBlock:         this.state.feedBlock !== null ? this.state.feedBlock : document.getElementById("feed-block"),
			videoTrendBlock:   document.getElementById("trending-videos-block"),
			videoStationBlock: document.getElementById("video-station-block"),
			newGirlsBlock:     document.getElementById("new-girls-block"),
			contestsBlock:     this.state.contestsBlock !== null ? this.state.contestsBlock : document.getElementById("contests-block"),
			welcomeClipsBlock: document.getElementById("welcome-clips-block"),
			categoriesBlock:   document.getElementById("categories-block"),
			tvBlock:           document.getElementById("tv-series-block"),
		};

		this.setState({
			blocks:       items,
			activeItemId: document.getElementById("favorite-block") ? Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.FAVORITE : Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.TOP,
		});
	}

	onScroll() {
		const blockList = [
			{
				pos:    this.getBlockPosition(this.state.blocks.favoriteBlock),
				height: this.getBlockHeight(this.state.blocks.favoriteBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.FAVORITE,
			},
			{
				pos:    this.getBlockPosition(this.state.blocks.topLiveBlock),
				height: this.getBlockHeight(this.state.blocks.topLiveBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.TOP,
			},
			this.state.camShowsBlock && {
				pos:    this.getBlockPosition(this.state.camShowsBlock !== null ? this.state.camShowsBlock : this.state.blocks.camShowsBlock),
				height: this.getBlockHeight(this.state.camShowsBlock !== null ? this.state.camShowsBlock : this.state.blocks.camShowsBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.CAMSHOWS,
			},
			this.state.feedBlock && {
				pos:    this.getBlockPosition(this.state.feedBlock !== null ? this.state.feedBlock : this.state.blocks.feedBlock),
				height: this.getBlockHeight(this.state.feedBlock !== null ? this.state.feedBlock : this.state.blocks.feedBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.FEED,
			},
			{
				pos:    this.getBlockPosition(this.state.blocks.dailyBonusBlock),
				height: this.getBlockHeight(this.state.blocks.dailyBonusBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.DAILYBONUS,
			},
			{
				pos:    this.getBlockPosition(this.state.blocks.vip30Block),
				height: this.getBlockHeight(this.state.blocks.vip30Block),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.VIP30,
			},
			{
				pos:    this.getBlockPosition(this.state.blocks.videoTrendBlock),
				height: this.getBlockHeight(this.state.blocks.videoTrendBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.TRENDS,
			},
			{
				pos:    this.getBlockPosition(this.state.blocks.videoStationBlock),
				height: this.getBlockHeight(this.state.blocks.videoStationBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.VIDEOSTATION,
			},
			{
				pos:    this.getBlockPosition(this.state.blocks.newGirlsBlock),
				height: this.getBlockHeight(this.state.blocks.newGirlsBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.NEW,
			},
			this.state.contestsBlock && {
				pos:    this.getBlockPosition(this.state.contestsBlock !== null ? this.state.contestsBlock : this.state.blocks.contestsBlock),
				height: this.getBlockHeight(this.state.contestsBlock !== null ? this.state.contestsBlock : this.state.blocks.contestsBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.CONTESTS,
			},
			{
				pos:    this.getBlockPosition(this.state.blocks.welcomeClipsBlock),
				height: this.getBlockHeight(this.state.blocks.welcomeClipsBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.WELCOMECLIPS,
			},
			{
				pos:    this.getBlockPosition(this.state.blocks.categoriesBlock),
				height: this.getBlockHeight(this.state.blocks.categoriesBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.CATEGORIES,
			},
			{
				pos:    this.getBlockPosition(this.state.blocks.tvBlock),
				height: this.getBlockHeight(this.state.blocks.tvBlock),
				name:   Flux.Constants.TIMELINE_NAVIGATION.BLOCKS.TV,
			},
		];

		const filteredBlockList = blockList.filter(v => v && v.pos !== 0);
		const found             = filteredBlockList.find(function(element) {
			if (element.pos <= window.pageYOffset && (element.pos + element.height) > window.pageYOffset) {
				return element;
			}

		});
		if (typeof found !== 'undefined' && (this.state.activeItemId === null || this.state.activeItemId !== found.name)) {
				this.setState({
					activeItemId: found.name,
				});
			}
	}

	setCamShowsBlock(el) {
		if (this.state.camShowsBlock === null) {
			this.setState({camShowsBlock: el}, () => this.setBlocks());
		}
	}

	setFeedBlock(el) {
		if (this.state.feedBlock === null) {
			this.setState({feedBlock: el}, () => this.setBlocks());
		}
	}

	setContestsBlock(el) {
		if (this.state.contestsBlock === null) {
			this.setState({contestsBlock: el}, () => this.setBlocks());
		}
	}

    render() {
        const isLoggedIn   = Flux.Guest.isLoggedIn();
        const isEntryPage  = VXConfig.isEntryPage;
        const isGermanUser = VXConfig.language === Constants.Languages.DE;
        const fsk          = isLoggedIn ? (Flux.Guest.hasAvs() ? 18 : 16) : 0;
        const {
                  showCams           = 0,
                  showCamsExtended   = 0,
                  showCamShows       = 0,
                  showTrending       = 0,
                  showFeed           = 0,
                  showCategories     = 0,
                  showDailyBonus     = 0,
                  showFavorites      = 0,
                  showMainTeaser     = 0,
                  showMediathek      = 0,
                  showNewCams        = 0,
                  showTeaser         = 0,
                  showVideoStation   = 0,
                  showVipClub        = 0,
                  showWelcomeClip    = 0,
                  showContests       = 0,
                  showSideNavigation = 0
              }            = VXConfig.startpageConfig;

        const navi = withSuspense(<PageNavigation items={this.state.blocks} activeItemId={this.state.activeItemId} />);
        const cams = withSuspense(<Cams isHomepage={true} as="section" />);

        const blockConfigs = [
            {
                show: !isEntryPage ? showMainTeaser : 0,
                component: <TeaserProvider as="section" />
            },
            {
                show: showFavorites,
                component: <FavoritesBlock {...this.props.favorites} isGuestLoggedIn={isLoggedIn} />
            },
            {
                show: showCams,
                component: <TopLiveCamGirlsBlock
                              tileGridConfig={this.props.topCams.tiles}
                              tileGridTotal={this.props.topCams.total}
                              link={this.props.topCams.link}
                              lazyImageLoading={false}
                              title={getSeoHeadlineTranslation(Flux.Browser.isSexole() ? 'homepage_topcams_h1--sexole' : 'homepage_topcams_h1')}
                              headlineType={Flux.Constants.Headlines.h2}
                              doGaTracking={true}
                      />
            },
            {
                show: showCamShows,
                component: <CamShowsBlock parentCallback={this.setCamShowsBlock} lazyImageLoading={!!this.state.blocks.favoriteBlock} />
            },
            {
                show: showCamsExtended,
                component: cams
            },
            {
                show: showFeed,
                component: <ErrorBoundary><FeedBlock parentCallback={this.setFeedBlock} isMobile={false} as="section" /></ErrorBoundary>
            },
            {
                show: !isEntryPage ? showDailyBonus : 0,
                component: <ErrorBoundary><DailybonusBlock lazyImageLoading={true} doGaTracking={true} show={true} isMobile={false} /></ErrorBoundary>
            },
            {
                show: showVipClub,
                component: <VIP30Block lazyImageLoading={true} doGaTracking={true} videoTitleType={"h3"} as="section" />
            },
            {
                show: showTrending,
                component: <TrendingVideosBlock isGuestLoggedIn={isLoggedIn} lazyImageLoading={true} />
            },
            {
                show: !isEntryPage ? showVideoStation : 0,
                component: <VideoStationBlock
                              {...this.props.videoJumbotron}
                              isGuestLoggedIn={isLoggedIn}
                              lazyImageLoading={true}
                              title={getSeoHeadlineTranslation(Flux.Browser.isSexole ? 'homepage_videostation_h2--sexole' : 'homepage_videostation_h2')}
                              headlineType={Flux.Constants.Headlines.h2}
                              doGaTracking={true}
                      />
            },
            {
                show: !isEntryPage ? showTeaser : 0,
                component: <TeaserBlock teaserContext="promotion" />
            },
            {
                show: showNewCams,
                component: <NewGirlsBlock
                              link={UrlBuilder.buildNewActorsUrl()}
                              lazyImageLoading={true}
                              title={getSeoHeadlineTranslation('homepage_newgirls_h2')}
                              headlineType={Flux.Constants.Headlines.h2}
                              isMobile={false}
                      />
            },
            {
                show: showContests,
                component: <Competitions contestsLink={this.props.contestsLink} parentCallback={this.setContestsBlock} as="section" />
            },
            {
                show: isGermanUser ? showWelcomeClip : 0,
                component: withSuspense(<WelcomeClipsBlock playlist={this.props.welcomeClip.playlist} lazyImageLoading={true} fsk={fsk} />)
            },
            {
                show: !isEntryPage ? showCategories : 0,
                component: <CategoriesBlock
                              total={this.props.categories.total}
                              link={this.props.categories.link}
                              title={getSeoHeadlineTranslation('homepage_categories_h2')}
                              headlineType={Flux.Constants.Headlines.h2}
                      />
            },
            {
                show: !isEntryPage ? showMediathek : 0,
                component: <TVSeriesBlock
                              tileCount={12}
                              link={UrlBuilder.buildTVSeriesOverviewRoute()}
                              grid={TVSeriesHomepageGrid}
                              lazyImageLoading={true}
                              title={getSeoHeadlineTranslation('homepage_tv_h2')}
                              headlineType={Flux.Constants.Headlines.h2}
                              doGaTracking={true}
                      />
            }
        ];
        const sortedAndFilteredConfigs = sortAndFilterBlockConfigs(blockConfigs);

        return (
                <div id="blocks-container">
                    {(showSideNavigation && !VXConfig.isVXMobilePlatform && !VXConfig.device.isTablet) ? navi : ''}
                    {sortedAndFilteredConfigs.map((config, index) => (
                            <React.Fragment key={index}>{config.component}</React.Fragment>
                    ))}
                </div>
        );
    }
}

/**
 * @see HomepagePM::jsonSerialize
 */
AllBlocks.propTypes = {
	dailyBonus:     PropTypes.object,
	topCams:        PropTypes.shape({
		tiles: PropTypes.object.isRequired,
		total: PropTypes.number,
		link:  PropTypes.string.isRequired,
	}),
	welcomeClip:    PropTypes.shape({
		playlist: PropTypes.array,
	}),
	categories:     PropTypes.shape({
		total: PropTypes.number,
		link:  PropTypes.string.isRequired,
	}),
	newAmateurs:    PropTypes.shape({
		link:  PropTypes.string.isRequired,
	}),
	favorites:      PropTypes.shape(FavoritesBlock.propTypes),
	videoJumbotron: PropTypes.shape({
		config: PropTypes.object,
		link:   PropTypes.string,
	}),
	contestData:    PropTypes.object,
	contestsLink:   PropTypes.string,
};

AllBlocks.defaultProps = {
	favorites:   {
		total: 0,
	},
	topCams:     {
		total: 0,
	},
	welcomeClip: {
		playlist: [],
	},
	categories:  {
		list:  [],
		total: 0,
	},
};

export default AllBlocks;
